import { State, Selector, Action, StateContext } from '@ngxs/store';
import { WBidStateCollection } from '../../models/WBidStateCollection';
import { AddStateFile, RemoveStateFile } from '../actions/stateFile.action';

export class StateFileStateModel {
  stateFile: WBidStateCollection;
}

@State({
  name: 'stateFile',
  defaults: {
    stateFile: undefined,
  },
})
export class StateFileState {
  @Selector()
  getStateFile(state: StateFileStateModel) {
    return state.stateFile;
  }

  @Action(AddStateFile)
  add(
    { patchState }: StateContext<StateFileStateModel>,
    { payload }: AddStateFile
  ) {
    patchState({ stateFile: payload });
  }

  @Action(RemoveStateFile)
  remove({ patchState }: StateContext<StateFileStateModel>) {
    patchState({ stateFile: undefined });
  }
}
